import { call, put, takeLatest } from "redux-saga/effects"
import {
  GET_OPTIONS_WATCHER,
  GET_INFO_COMPANY_WATCHER,
  PUT_INFO_COMPANY_WATCHER,
} from "./constants"
import {
  getOptionsSuccess,
  getOptionsFailed,
  getInfoCompanyWatcher,
  getInfoCompanySuccess,
  getInfoCompanyFailed,
} from "./actions"
import { getUserWatcher } from "../../UserHeaderBox/actions"
import {
  KEY_COMPANY_LOGO,
  LOCAL_COMPANY_ID,
  setItem,
} from "../../../utils/storage"

// GET OPTIONS
export function* getOptionsSaga() {
  try {
    // const { data, status } = yield call(getOptionsApi);
    const { data, status } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: "companies/create",
    })

    if (status === 200) {
      yield put(getOptionsSuccess(data))
    }
  } catch (error) {
    yield put(getOptionsFailed({}))
    returnMessage(error)
  }
}

// GET INFO COMPANY
export function* getInfoCompanySaga() {
  try {
    const { data, status } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `companies/${LOCAL_COMPANY_ID()}`,
    })

    if (status === 200) {
      yield put(getInfoCompanySuccess(data.data))
    }
  } catch (error) {
    yield put(getInfoCompanyFailed())
    returnMessage(error)
  }
}

// PUT INFO COMPANY
export function* putInfoCompanySaga(action) {
  try {
    const {
      data: {
        data,
        data: {
          result: { company },
        },
      },
    } = yield call(fetchGlobalApi, {
      method: "POST",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/upload`,
      data: action.payload,
    })

    if (
      typeof action.payload.name === "undefined" ||
      typeof action.payload.logo !== "undefined"
    ) {
      setItem(KEY_COMPANY_LOGO, company.logo)
      window.message.success(data.msj, 5)
      yield put(getInfoCompanyWatcher())
      yield put(getUserWatcher())
    } else {
      window.message.success(data.msj, 5)
      yield put(getInfoCompanyWatcher())
    }
  } catch (error) {
    yield put(getInfoCompanyFailed())
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* accountSaga() {
  yield takeLatest(GET_OPTIONS_WATCHER, getOptionsSaga)
  yield takeLatest(GET_INFO_COMPANY_WATCHER, getInfoCompanySaga)
  yield takeLatest(PUT_INFO_COMPANY_WATCHER, putInfoCompanySaga)
}
